__turbopack_context__.v({
  "alignLeft": "Utilities-module__ayyteG__alignLeft",
  "alignRight": "Utilities-module__ayyteG__alignRight",
  "ellipsis": "Utilities-module__ayyteG__ellipsis",
  "hide": "Utilities-module__ayyteG__hide",
  "negative": "Utilities-module__ayyteG__negative",
  "positive": "Utilities-module__ayyteG__positive",
});
